import clsx from 'clsx'
import { Button, Col, Search, Space } from 'components/common'

export interface ProductSearchProps {
  searchResult?: string
  warningMessage?: string
  onSearch?: () => void
  setSearchResult?: (params: string) => void
  searchClear?: () => void
}

export const ProductSearch = ({
  warningMessage,
  onSearch,
  searchClear,
  searchResult,
  setSearchResult,
}: ProductSearchProps): JSX.Element => {
  return (
    <div style={{ marginBottom: 10 }}>
      {warningMessage && (
        <div className="ml-2 text-red-600">{warningMessage}</div>
      )}
      <Col span={24} className={clsx('flex', 'flex-end', 'justify-end')}>
        <Space direction="horizontal">
          <Search
            autoComplete="off"
            placeholder="施設を絞り込む"
            value={searchResult}
            onChange={(e) => setSearchResult(e.target.value)}
            onPressEnter={() => onSearch()}
          />

          <Button onClick={onSearch}>絞り込む</Button>
          <Button onClick={searchClear}>クリア</Button>
        </Space>
      </Col>
    </div>
  )
}
